export const PAID_VARIANTS = ['all', 'paid', 'free'] as const;
export const SORT_VARIANTS = ['popular', 'rating'] as const;

export type PaidVariants = (typeof PAID_VARIANTS)[number];
export type SortVariants = (typeof SORT_VARIANTS)[number];
